module.exports = __webpack_public_path__ + "images/thinking-face-gif-2.gif";